import React, {useCallback} from "react";
import {Field} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {
    CourseDropDown,
    UniversityCourseDropDownInterface,
} from "../../../../containers/RegistrationLoginPage/types";

import SelectV2 from "../../../HTMLEntities/SelectV2";
import {SINGLE_SELECT} from "../../../HTMLEntities/SelectV2/utils";
import {UseComboboxState} from "downshift";
import useLevelHandler from "../../../../hooks/useLevelHandler";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";

interface UserCityFieldInterface {
    configuration: UniversityCourseDropDownInterface;
}
const UniversityCourseDropDown: React.FC<UserCityFieldInterface> = ({
    configuration,
}: UserCityFieldInterface) => {
    const {fieldName, values: dropDownValues, selectedValue, editable} = configuration;
    const levelCallback = useLevelHandler();
    const setFormLevel = useCallback(
        (obj: Partial<UseComboboxState<CourseDropDown>>) => {
            const level = obj.selectedItem?.level;
            level && levelCallback({level});
        },
        [levelCallback],
    );
    return (
        <Field<CourseDropDown>
            name={fieldName}
            validate={composeValidators(
                regRequiredValidate("Please select course at this university"),
            )}
            {...(selectedValue ? {initialValue: selectedValue} : {})}
            validateFields={[]}
        >
            {(props) => {
                return (
                    <SelectV2
                        placeholder="Select course at this University"
                        searchPlaceholder="Search course at this University"
                        type={SINGLE_SELECT}
                        items={dropDownValues ?? []}
                        onSelectedItemChange={setFormLevel}
                        inputRFF={props.input}
                        withSearch={true}
                        isFocused={props?.meta?.active ?? false}
                        isTouched={props?.meta?.touched}
                        isDisabled={!editable}
                        error={errorHandler(props?.meta)}
                        selectedOption={selectedValue ? [selectedValue] : undefined}
                        isFilled={typeof props.input.value === "object"}
                    />
                );
            }}
        </Field>
    );
};
export default UniversityCourseDropDown;
